<template>

  <div ref="treeContainer" class="flex flex-col">
    <div
      class="flex flex-row items-center px-2 py-1 cursor-pointer rounded hover:bg-gray-100"
      :class="{ 'bg-primary-100 text-primary font-medium': selectedFolderId === null, 'bg-blue-100 border border-blue-300': highlightedFolderId === '__root__' }"
      data-folder-id="__root__"
      @click="$emit('folderSelected', null)"
      @dragover.prevent="rootDragOver = true"
      @dragleave="rootDragOver = false"
      @drop.prevent="onRootDrop"
    >
      <font-awesome-icon icon="home" class="mr-2 text-sm text-primary" />
      <p class="text-sm">All other files</p>
    </div>
    <FolderNode
      v-for="folder in rootFolders"
      :key="folder.ID"
      :folder="folder"
      :folders="folders"
      :selectedFolderId="selectedFolderId"
      :highlightedFolderId="highlightedFolderId"
      :expandedIds="expandedIds"
      :depth="0"
      @folderSelected="(id) => $emit('folderSelected', id)"
      @toggleExpand="toggleExpand"
      @itemDropped="(id) => emit('itemDropped', id)"
    />
    <hr class="border-b border-gray-200">
    <button class="primary" @click="emit('createFolder')">Create Folder</button>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import FolderNode from "./FolderNode.vue";

const props = defineProps({
  folders: Array,
  selectedFolderId: [String, null],
  highlightedFolderId: [String, null],
});

const emit = defineEmits(["folderSelected", "itemDropped", "createFolder"]);

const treeContainer = ref(null);
const expandedIds = ref(new Set());
const rootDragOver = ref(false);

const onRootDrop = () => {
  rootDragOver.value = false;
  emit("itemDropped", null);
};

const rootFolders = computed(() => {
  return (props.folders || []).filter((f) => !f.Parent);
});

const toggleExpand = (id) => {
  if (expandedIds.value.has(id)) {
    expandedIds.value.delete(id);
  } else {
    expandedIds.value.add(id);
  }
  expandedIds.value = new Set(expandedIds.value);
};

defineExpose({ treeContainer });
</script>
